// 行動ルール (behaviorRule) catalogue。docs/04 §4.2 / §4.2.1 / docs/15 §C.1
// および docs/adr/0020-behavior-rule-roll.md。
//
// ドロップ生成 (loot.ts `rollBehaviorRule`) が参照する 2 つのテーブル:
//   - SLOT_BEHAVIOR_CATEGORY: スロット → behaviorRule カテゴリの固定写像 (7 スロット)
//   - DAMAGE_REACT_CATALOGUE: damageReact カテゴリの `DamageReactRule` 9 件
//
// 5 単純カテゴリ (targeting / movement / tempo / threatPolicy / positionPolicy) の
// 抽選プールは shared の ID 配列定数 (TARGETING_RULES 等) をそのまま使うため、本
// ファイルでは再定義しない。
//
// damageReact の trigger / override / priority / durationTicks は docs/04 §4.2.1 の
// 表に完全準拠。override の sim 適用 reducer は Phase 1 MVP 未実装でスコープ外。
import { seconds } from '@renavora/shared';
/**
 * スロット → behaviorRule カテゴリの固定写像 (docs/04 §4.2)。
 * weaponMain / offHand / belt / cloak はカテゴリを持たず、写像に含めない
 * (生成アイテムは behaviorRule を省略する、ADR 0020 §D1)。
 */
export const SLOT_BEHAVIOR_CATEGORY = {
    head: 'targeting',
    boots: 'movement',
    hands: 'tempo',
    chest: 'threatPolicy',
    amulet: 'positionPolicy',
    ring1: 'damageReact',
    ring2: 'damageReact',
};
/**
 * damageReact カテゴリの `DamageReactRule` catalogue (docs/04 §4.2.1、9 種)。
 * trigger (閾値発火条件) × overrides (上書き先カテゴリ + ID) + priority + duration。
 */
export const DAMAGE_REACT_CATALOGUE = [
    {
        ruleId: 'react_hp50_kite',
        trigger: { stat: 'hp%', threshold: 50, op: 'lt' },
        overrides: [{ category: 'movement', ruleId: 'move_distance_long' }],
        priority: 5,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_hp25_emergency',
        trigger: { stat: 'hp%', threshold: 25, op: 'lt' },
        overrides: [
            { category: 'movement', ruleId: 'move_distance_long' },
            { category: 'tempo', ruleId: 'tempo_conserve' },
        ],
        priority: 8,
        durationTicks: seconds(8),
    },
    {
        ruleId: 'react_hp25_lastditch',
        trigger: { stat: 'hp%', threshold: 25, op: 'lt' },
        overrides: [{ category: 'tempo', ruleId: 'tempo_burst' }],
        priority: 7,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_shield_break_retreat',
        trigger: { stat: 'event', event: 'shield_break' },
        overrides: [{ category: 'movement', ruleId: 'move_distance_mid' }],
        priority: 6,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_ally_low_support',
        trigger: { stat: 'allyHp%', threshold: 30, op: 'lt' },
        overrides: [{ category: 'positionPolicy', ruleId: 'pos_ally_triangle' }],
        priority: 6,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_hp50_threat_drop',
        trigger: { stat: 'hp%', threshold: 50, op: 'lt' },
        overrides: [{ category: 'threatPolicy', ruleId: 'threat_low' }],
        priority: 5,
        durationTicks: seconds(8),
    },
    {
        ruleId: 'react_focused_hide',
        trigger: { stat: 'event', event: 'attacked' },
        overrides: [{ category: 'positionPolicy', ruleId: 'pos_behind_tank_anchor' }],
        priority: 7,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_ally_critical_ult',
        trigger: { stat: 'allyHp%', threshold: 10, op: 'lt' },
        overrides: [{ category: 'tempo', ruleId: 'tempo_ult_focus' }],
        priority: 9,
        durationTicks: seconds(5),
    },
    {
        ruleId: 'react_self_buffed_aggro',
        trigger: { stat: 'event', event: 'self_buffed' },
        overrides: [{ category: 'threatPolicy', ruleId: 'threat_high' }],
        priority: 5,
        durationTicks: seconds(6),
    },
];
//# sourceMappingURL=behavior-rules.js.map